import * as $ from 'jquery';

/**
 * Gets the base width of the shed.
 * 
 * @returns {number} The base width of the shed.
 */
export const getBaseWidth = () => {
    return Number( $( '.ssb-option.size-area' ).children( 'option:selected' ).data( 'size-width' ) );
}

/**
 * Gets the base depth of the shed.
 * 
 * @returns {number} The base depth of the shed.
 */
export const getBaseDepth = () => {
    return Number( $( '.ssb-option.size-area' ).children( 'option:selected' ).data( 'size-depth' ) );
}

/**
 * Gets the base height of the shed.
 * 
 * @returns {number} The base height of the shed.
 */
export const getBaseHeight = () => {
    return Number( $( '#ssb-configurator-size-height' ).children( 'option:selected' ).data( 'size-height' ) );
}

/**
 * Rounds a number to 3 decimal places.
 * 
 * @param {number} number - The number to round.
 * @returns {number} The rounded number.
 */
export const toFixed3 = ( number: Number ) => {
    return Number( Number( number ).toFixed( 3 ) );
}

/**
 * Calculates the sine of a given angle in degrees.
 * 
 * @param {number} degrees - Angle in degrees.
 * @returns {number} The sine of the given angle.
 */

export const getSinFromDegrees = ( degrees ) => {
    return Math.sin( degrees * Math.PI / 180 );
}

/**
 * Calculates the cosine of a given angle in degrees.
 * 
 * @param {number} degrees Angle in degrees.
 * @returns {number} The cosine of the given angle.
 */
export const getCosFromDegrees = ( degrees ) => {
    return Math.cos( degrees * Math.PI / 180 );
}

/**
 * Calculates the tangent of a given angle in degrees.
 * 
 * @param {number} degrees Angle in degrees.
 * @returns {number} The tangent of the given angle.
 */
export const getTanFromDegrees = ( degrees ) => {
    return Math.tan( degrees * Math.PI / 180 );
}


/**
 * Converts a measurement in feet to a string representation of the measurement in feet and inches.
 * If the measurement is less than 0, returns '0'.
 * @param {number} feet - The measurement in feet.
 * @returns {string} The measurement in feet and inches.
 */
export const convertUnit = feet => {
    if( 0 >= feet ) {
        return '0';
    }

    let integer         = Math.floor( feet );
    const decimal       = feet - integer;
    let feetUnit        = '';
    let inchUnit        = '';
    let tmp: any        = 0;
    if( decimal > 0 ) {
        if( isShowMeasurementsInDecimal() ) {
            tmp = parseFloat( ( decimal * 12 ).toFixed( 2 ) );
        } else {
            tmp = parseInt( ( decimal * 12 ).toFixed( 0 ) );
        }
        if( tmp > 0 ) {
            if ( tmp === 12 ) {
                integer += 1;
            } else {
                if( isShowMeasurementsInDecimal() && 'fraction' === getMeasurementsDecimalFormat() ) {
                    let tmpInchUnit : any   = Number( tmp );
                    let tmpInt              = Math.floor ( tmp );
                    let tmpDecimal          = tmpInchUnit % 1;
                    let faction : any       = convertDecimalToFaction( tmpDecimal.toFixed( 2 ) );
                    inchUnit                = tmpInt + '" ' + ( faction ? faction.display : '' );
                } else {
                    inchUnit = tmp + '"';
                }
            }
        }
    }

    if( integer > 0 ) {
        feetUnit = integer + "' ";
    }

    return feetUnit + inchUnit;
}

/**
 * Converts a decimal number into a fraction.
 *
 * @param {number} _decimal - The decimal number to convert.
 * @returns {false | {top: number, bottom: number, display: string}} 
 *          Returns false if the decimal is 0, otherwise an object containing:
 *          - 'top': The numerator of the fraction.
 *          - 'bottom': The denominator of the fraction.
 *          - 'display': A string representation of the fraction in the format "numerator/denominator".
 */

export const convertDecimalToFaction = ( _decimal ) => {
    if( 0 == _decimal ) return false;
    var top		= _decimal.toString().replace( /\d+[.]/, '' );
	var bottom	= Math.pow(10, top.length);
	if( _decimal > 1 ) {
		top	= +top + Math.floor( _decimal ) * bottom;
	}
	var x = getDenominator( top, bottom );
	return {
		top		: ( top / x ),
		bottom	: ( bottom / x ),
		display	: ( top / x ) + '/' + ( bottom / x )
	};
}

/**
 * Calculates the greatest common divisor of two numbers using the Euclidean algorithm.
 *
 * @param {number} a - The first number.
 * @param {number} b - The second number.
 * @returns {number} The greatest common divisor of the two numbers.
 */
export const getDenominator = ( a, b ) => {
	return b ? getDenominator( b, a % b ) : a;
}

/**
 * Checks if the current settings are to show measurements in decimal format.
 * 
 * @returns {boolean} True if show measurements in decimal, false otherwise.
 */
export const isShowMeasurementsInDecimal = () => {
    return "1" == ( <any>window ).shedpro.show_measurements_in_decimal;
}

/**
 * Retrieves the current format for displaying measurements.
 *
 * @returns {string} The current format, either 'fraction' or 'decimal'.
 */
export const getMeasurementsDecimalFormat = () => {
    return "fraction" == ( <any>window ).shedpro.measurements_format ? 'fraction' : 'decimal';
}
